module.exports = __webpack_public_path__ + "static/servientrega-e91010c7a4a85614e274b7fd4daeb885.webp";